import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'appstandardinfo',
    templateUrl: './appstandardinfo.component.html',
    styleUrls: ['./appstandardinfo.component.scss'],
    standalone: false
})
export class AppStandardInfoComponent implements OnInit {
    s1StandardInfo: any = null;
    showAppLoader: boolean = false;
    errorMessage: string = '';
    isImgToggle: boolean = true;
    isEnableEndpoints: boolean = false;
    envURL: string = environment.baseUrl;

    ngOnInit() {
        this.getS1StandardInfo();
    }

    public getS1StandardInfo() {
        if (AuthenticationService.s1StandardInfo) {
            this.s1StandardInfo =  AuthenticationService.s1StandardInfo;
            this.showAppLoader=false;
            this.isEnableEndpoints=true;
        } else {
            this.showAppLoader = true;
            this.errorMessage = '';
        }
    }

}